"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectComponent = void 0;
const react_1 = __importStar(require("react"));
const react_select_1 = __importDefault(require("react-select"));
require("./styles.scss");
const SelectComponent = (props) => {
    const { options = [], onChangeValue } = props;
    const customStyle = {
        control: (baseStyles, state) => (Object.assign(Object.assign({}, baseStyles), { borderColor: "#60C392", borderRadius: "20px", backgroundColor: "inherit", width: window.innerWidth > 600 ? "150px" : "100%", fontSize: "21px", color: "#60C392", boxShadow: "none", "&:hover": {
                borderColor: "rgb(165, 165, 165)",
            } })),
        dropdownIndicator: (base) => (Object.assign(Object.assign({}, base), { color: "#60C392" })),
        option: (provided, state) => (Object.assign(Object.assign({}, provided), { color: "black", backgroundColor: state.isSelected ? "#60c392" : "white", "&:hover": {
                backgroundColor: state.isSelected ? "#60c392" : "rgb(165, 165, 165)",
            } })),
        singleValue: (provided) => (Object.assign(Object.assign({}, provided), { color: "#60C392" })),
        indicatorSeparator: (base) => (Object.assign(Object.assign({}, base), { backgroundColor: "#60C392" })),
    };
    const [selectedOption, setSelectedOption] = (0, react_1.useState)(options[0]);
    return (react_1.default.createElement("div", { className: "c-select" },
        react_1.default.createElement(react_select_1.default, { value: selectedOption, onChange: (option) => {
                onChangeValue((option === null || option === void 0 ? void 0 : option.value) || options[0].value);
                setSelectedOption(option || options[0]);
            }, options: options, styles: customStyle })));
};
exports.SelectComponent = SelectComponent;
